var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":!_vm.connected,"max-width":"600"}},[_c('div',{staticClass:"need_login_dialog style_dialog"},[_c('h2',{staticClass:"header"},[_vm._v(" Oops! ")]),_c('div',{staticClass:"cnt"},[_vm._v(" Connection interrupted. Reconnecting in "+_vm._s(_vm.secondsRemaining)+" seconds... ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }